import {
  specialEquipmentSubtypeLabel,
} from "../vehicle/vehicleCatalog.js";

import {
  SPECIAL_PERFORMER_SUBTYPES,
} from "./performerCatalog.js";

export default function SpecialAssetFields({
  form,
  setForm,
  setError,
  language,
}) {
  return (
    <div
      className="reisor-special-subtype-grid"
      data-reisor-special-subtype-picker="register"
    >
      {SPECIAL_PERFORMER_SUBTYPES.map((value) => (
        <button
          key={value}
          type="button"
          className={`reisor-special-subtype-option ${
            String(form.bodyTypeOther || "") === value
              ? "is-selected"
              : ""
          }`}
          onClick={() => {
            setError("");

            setForm((prev) => ({
              ...prev,
              bodyType: "Спецтехника",
              bodyTypeOther: value,
              assetType: "SPECIAL_EQUIPMENT",
            }));
          }}
        >
          {specialEquipmentSubtypeLabel(
            value,
            language
          )}
        </button>
      ))}
    </div>
  );
}
